import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateSeanceInTime } from 'src/store/actions/seance-actions';
import { toast } from 'react-toastify';
import { DropdownList } from 'react-widgets';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import GeneralEnum from '../../../../../../../enumerables/general-enum';
import user from '../../../../../../../services/user-auth';
import UserRole from '../../../../../../../enumerables/user-role';
import { ISeance } from '../../../../../../../types/seance';

interface Props {
    data: ISeance;
}

const ConfirmInTimeAction: React.FunctionComponent<Props> = ({ data: { id, isConfirmInTime, status } }: Props) => {
    const dispatch = useDispatch();

    const [valueInTime, setValueInTime] = useState<boolean>(isConfirmInTime);
    const [valStatus, setValStatus] = useState<any>({ label: 'yes', value: true });

    const statuses: SelectObject[] = [
        { label: 'yes', value: true },
        { label: 'no', value: false },
    ];

    const onChangeDrop = (st: boolean) => {
        setValueInTime(st);
        dispatch(
            updateSeanceInTime({ id, isConfirmInTime: st, isConfirmInTimeManually: true }, [], {
                resolve: () => {
                    //  toast.success('IsConfirmInTime successfully updated!');
                },
                reject: (errorMessage: string) => {
                    // toast.error(errorMessage);
                },
            }),
        );
    };

    useEffect(() => {
        // setValueInTime(isConfirmInTime);
        if (valueInTime != valStatus?.value) {
            statuses.forEach((it) => {
                if (+it.value === +valueInTime) {
                    setValStatus(it);
                }
            });
        }
    }, [valueInTime]);

    //  let valStatus = { label: 'yes', value: true };

    const selectValuesStatus: SelectObject[] = [];
    statuses.forEach((it) => {
        selectValuesStatus.push(it);
        /*if (+it.value === +isConfirmInTime) {
         //   setValStatus(it);
        }*/
    });

    return (
        <>
            <div>
                {user.getRoles().includes(UserRole.ROLE_ADMIN) && isConfirmInTime == false ? (
                    <DropdownList
                        data={selectValuesStatus}
                        containerClassName={'w-100'}
                        textField="label"
                        valueField="value"
                        onChange={(item: SelectObject) => {
                            onChangeDrop(item.value);
                        }}
                        value={valStatus}
                    />
                ) : status == 4 ? (
                    valStatus.label
                ) : (
                    ''
                )}
            </div>
        </>
    );
};

export default ConfirmInTimeAction;
